var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticStyle: { height: "25%" } }, [
    _c("div", { staticClass: "devideLine" }),
    _c("div", { staticClass: "flex panel", staticStyle: { height: "100%" } }, [
      _c("div", { staticClass: "panelLeft" }, [
        _c("img", {
          attrs: { src: require("images/index/home/y1.png"), alt: "" },
        }),
        _c("img", {
          attrs: { src: require("images/index/home/y2.png"), alt: "" },
        }),
        _c("img", {
          attrs: { src: require("images/index/home/y3.png"), alt: "" },
        }),
        _c("div", [
          _c("p", [
            _c("span", { staticClass: "num" }, [_vm._v(_vm._s(_vm.zhcg))]),
          ]),
          _c("p", [_vm._v("成果")]),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "panelRight flex" },
        _vm._l(_vm.list, function (item, index) {
          return _c("div", { key: index }, [
            _c("img", { attrs: { src: item.img, alt: "" } }),
            _c("div", [
              _c("p", [_vm._v(_vm._s(item.name))]),
              _c("p", [
                _c("span", { staticClass: "num" }, [
                  _vm._v(_vm._s(item.value)),
                ]),
                _vm._v("(" + _vm._s(item.unit) + ") "),
              ]),
            ]),
          ])
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }